/**
 * The ship structure graph.
 *
 * A ship is a planar straight-line graph laid out on a 2D plane: joints are
 * vertices, lines are edges. Everything else about a ship — its compartments,
 * its surface area, which components are protected and which are exposed — is
 * derived from this graph rather than stored alongside it, so there is exactly
 * one thing to keep consistent when damage changes the structure.
 *
 * The 3D depth seen in flight is a rendering-only extrusion of the enclosed
 * area. Physics stays 2D.
 */
export const EPSILON = 1e-9;
/**
 * How far a line's stored `length` is from the actual distance between its
 * endpoints. Should be ~0 for a validly placed line.
 */
export function lineLengthError(line, joints) {
    const a = joints.get(line.a);
    const b = joints.get(line.b);
    if (!a || !b)
        return null;
    return Math.abs(Math.hypot(b.x - a.x, b.y - a.y) - line.length);
}
export function indexJoints(graph) {
    return new Map(graph.joints.map((j) => [j.id, j]));
}
export function indexLines(graph) {
    return new Map(graph.lines.map((l) => [l.id, l]));
}
//# sourceMappingURL=types.js.map